module.exports = __webpack_public_path__ + "media/images/help/image3-22ef0914dcef26d13aba061438686fcb.jpeg";